module.exports = __webpack_public_path__ + "img/fondo3.dd75e261.png";